import noticePc from './notice-pc.vue'

export default noticePc
